import { Subject } from "rxjs";
import { IAccount } from "./account.model";

export class Page {
    loading: boolean;
    error: boolean;
    loaded: boolean;
    unSubscribe: Subject<any>;
    account: IAccount;

    constructor() {
        this.loading = true;
        this.error = false;
        this.loaded = false;
        this.unSubscribe = new Subject();
    }
}